// components/MenuItemsTable/GstPopup.js
import React from 'react';

const GstPopup = ({ isOpen, onClose, gstBreakdownData }) => {
  if (!isOpen || !gstBreakdownData) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 2000
    }} onClick={onClose}>
      <div style={{
        backgroundColor: '#fff',
        borderRadius: '16px',
        padding: '24px',
        width: '90%',
        maxWidth: '400px',
        position: 'relative'
      }} onClick={e => e.stopPropagation()}>
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            right: '16px',
            top: '16px',
            background: 'none',
            border: 'none',
            fontSize: '20px',
            cursor: 'pointer'
          }}
        >
          ✕
        </button>
        <h3 style={{ margin: '0 0 20px 0', color: '#ee6521' }}>GST Breakdown</h3>
        <div>
          {gstBreakdownData.serviceChargeGst > 0 && (
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0', borderBottom: '1px solid #eee' }}>
              <span>Service Charge GST:</span>
              <span>₹{gstBreakdownData.serviceChargeGst.toFixed(2)}</span>
            </div>
          )}
          {gstBreakdownData.platformChargeGst > 0 && (
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0', borderBottom: '1px solid #eee' }}>
              <span>Platform Charge GST:</span>
              <span>₹{gstBreakdownData.platformChargeGst.toFixed(2)}</span>
            </div>
          )}
          {gstBreakdownData.cgst > 0 && (
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0', borderBottom: '1px solid #eee' }}>
              <span>CGST:</span>
              <span>₹{gstBreakdownData.cgst.toFixed(2)}</span>
            </div>
          )}
          {gstBreakdownData.sgst > 0 && (
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0', borderBottom: '1px solid #eee' }}>
              <span>SGST:</span>
              <span>₹{gstBreakdownData.sgst.toFixed(2)}</span>
            </div>
          )}
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '12px 0',
            fontWeight: 'bold',
            borderTop: '2px solid #ddd',
            marginTop: '8px'
          }}>
            <span>Total GST:</span>
            <span style={{ color: '#ee6521' }}>
              ₹{(gstBreakdownData.cgst + gstBreakdownData.sgst + 
                  gstBreakdownData.serviceChargeGst + gstBreakdownData.platformChargeGst).toFixed(2)}
            </span>
          </div>
        </div>
        <button
          onClick={onClose}
          style={{
            width: '100%',
            padding: '12px',
            backgroundColor: '#ee6521',
            color: '#fff',
            border: 'none',
            borderRadius: '8px',
            marginTop: '20px',
            cursor: 'pointer'
          }}
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default GstPopup;